/**
 * Do not edit directly
 */

export default "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJhIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PGRlZnM+PHN0eWxlPi5ie2ZpbGwtcnVsZTpldmVub2RkO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYiIgZD0iTTE1LjAyLC4zN2wtNC44NiwxNS4yNi0zLjE0LTcuMzYsMy4wNC0zLjI5LC43MywuNjgtMi42LDIuODIsMS44Myw0LjI5TDEzLjQ0LDIuMDIsMy40OCw1Ljc1bDMuMTMsMS41Ni0uNDUsLjg5TC45OCw1LjYxLDE1LjAyLC4zN1oiLz48L3N2Zz4=";